import React, { Component } from "react";
import logo from "./assets/sonol-logo.png";
import errorImage from "./assets/error-image.png";
import DalkanVerifyForm from "./DalkanVerifyForm";

class VerifyDalkan extends Component {
  render() {
    return (
      <div className="gradient-container text-center">
        <img className="logo-wrapper" src={logo} alt="סונול" />
        <div className="white-error-container mx-auto">
          <div className="goods-gifts">
            <img className="error-image" src={errorImage} alt="" />
            <h2 className="error-header">קבלת אישור תדלוק אוטומטי</h2>
          </div>
          <div className="verify-dalkan-form verify-dalkan-form mx-auto">
            <div>
              {" "}
              על מנת שנוכל לטפל בפנייתך <br /> מלא את הפרטים הבאים{" "}
            </div>
            <DalkanVerifyForm />
          </div>
        </div>
      </div>
    );
  }
}

export default VerifyDalkan;



// WEBPACK FOOTER //
// ./src/VerifyDalkan.js